import React from 'react';

type Props = {
  htmlFor: string;
  required?: boolean;
  optionalHint?: string;
  children: React.ReactNode;
};

function FieldLabel({ htmlFor, required = false, optionalHint, children }: Props) {
  return (
    <label htmlFor={htmlFor} className="mb-2 block text-base font-semibold text-retino-darkviolet sm:text-sm">
      {children}
      {required && <span className="text-red-600">*</span>}
      {optionalHint && <span className="font-normal text-retino-darkgrey"> {optionalHint}</span>}
    </label>
  );
}

export default FieldLabel;
